import { compose, withHandlers } from 'recompose';
import { INTEGRATIONS_PATH } from '../constants';

export default compose(
  withHandlers({
    redirectToIntegration: props => (baseUrl, targetUrl) => {
      props.router.replace(`${baseUrl}${INTEGRATIONS_PATH}${targetUrl}`);
    },
  }),
);
